import BrandOS from "./BrandOS";

function App() {
  return <BrandOS />;
}

export default App;